export default () => {
  document.addEventListener('click', (e) => {
    if (!window._swat) return;

    const removeBtn = e.target.closest('[data-cart-wishlist-items] [data-remove-wishlist-item]');
    if (!removeBtn) return;

    const itemEl = removeBtn.closest('[data-cart-wishlist-item]');
    if (!itemEl) return;

    const remove_id = itemEl.getAttribute('data-cart-wishlist-item-id');
    const remove_object = window.wishlist_products.find(obj => obj.id === remove_id);

    if (typeof remove_object === 'undefined') return;

    window._swat.removeFromWishList({
      epi: remove_object.epi,
      du: remove_object.du,
      empi: remove_object.empi,
      iu: remove_object.iu,
    }, () => {
      // Successfully deleted, re-render page
      window.location.reload(false);
    });
  });
};
